import moment from 'moment';

export const getISODateFromDurationString = (duration: string) => {
  if (duration === '1W') {
    return moment().subtract(1, 'weeks').startOf('day').toISOString();
  }

  if (duration === '1M') {
    return moment().subtract(1, 'months').startOf('day').toISOString();
  }

  if (duration === '6M') {
    return moment().subtract(6, 'months').startOf('day').toISOString();
  }

  if (duration === '1Y') {
    return moment().subtract(1, 'years').startOf('day').toISOString();
  }

  return moment().toISOString();
};

export const isValidDate = (date: string | number) => {
  return moment(new Date(date), 'YYYY-MM-DD', true).isValid();
};
